import { renewalDiscountApplicationStatusSchema } from '@flux/shared';
import { createRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { OperationPage } from '@/features/operations/operation-page.js';
import { authenticatedRoute } from './authenticated.js';

/**
 * `/operations/$id` — fiche d'une opération (`02` §10) : Réglages / Commandes,
 * ou Réglages / Aperçu / Suivi pour une remise renouvellement (`07` §6).
 *
 * Onglet Suivi : liste des clients (`clientStatus`, `clientSearch`,
 * `clientPage`) et panneau d'un client (`client`, poussé dans l'historique) ;
 * onglet Aperçu : page du tableau (`previewPage`).
 * Une valeur illisible est ignorée plutôt que de faire échouer la page.
 */
const operationDetailSearchSchema = z.object({
  tab: z.enum(['reglages', 'commandes', 'apercu', 'suivi']).optional().catch(undefined),
  client: z.string().min(1).optional().catch(undefined),
  clientStatus: renewalDiscountApplicationStatusSchema.optional().catch(undefined),
  clientSearch: z.string().min(1).optional().catch(undefined),
  clientPage: z.coerce.number().int().min(1).optional().catch(undefined),
  /** Onglet Aperçu : page du tableau des renouvellements. */
  previewPage: z.coerce.number().int().min(1).optional().catch(undefined),
});

export const operationDetailRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/operations/$id',
  validateSearch: (search: Record<string, unknown>) => operationDetailSearchSchema.parse(search),
  component: OperationPage,
});
